import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Analytics, CampaignEditor, CampaignList, SpinLog } from '../../views/magicLamp';

/**
 * Magic Lamp
 *
 * Mounted under /magic-lamp in MainRouter, so it sits behind the portal's
 * ProtectedRoute and DashboardLayout like every other module.
 *
 * Lucky Spin lives at /magic-lamp/spin rather than at the index. Magic Lamp is
 * expected to grow other tools, and whichever was built first should not own
 * the module's front door.
 */
const MagicLampRouter = () => {
  return (
    <Routes>
      {/* Nothing at the index yet — the next Magic Lamp tool can claim it. */}

      <Route path="spin" element={<CampaignList />} />
      <Route path="spin/campaigns/:id" element={<CampaignEditor />} />
      <Route path="spin/analytics" element={<Analytics />} />
      <Route path="spin/log" element={<SpinLog />} />

      <Route path="*" element={<Navigate to="/magic-lamp/spin" replace />} />
    </Routes>
  );
};

export default MagicLampRouter;
